/** @module csi/heading/_AggregateWithNewMixin */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/underscore",
	"csi/action",
	"csi/action/New",
	"csi/store/_base",
	"csi/xml"
], function (declare, lang, _, csiAction, NewAction, csiStore, xml) {

	// This mixin will add a New action for the type to the aggregate dropdown.

	return declare(null, {
		/** @property {string} aggregateNewNodeType - type of node to allow creation of in drop down */
		aggregateNewNodeType: "",

		/** @property {Action} _newAction - action to create new node of given type */
		_newAction: null,

		/** @property {Names} _newStore - store holding results and new action */
		_newStore: null,

		/** @property {Widget} _widget - the input control widget attached */
		_widget: null,

		/**
		 * Allow custom error handling for New action
		 * @param {Controller} ac
		 * @param {Exception} err
		 */
		onNewError: function (ac, err) { },

		/**
		 * Add New action to drop-down
		 * @param {Context} ctx
		 * @param {Context} params
		 * @return {_WidgetBase}
		 */
		_toHtmlDynamic: function (ctx, params) {
			var w = this.inherited(arguments);
			var action = this._getNewAction();
			if (action) {
				action.resolve();
				this._newAction = action;
				this.namesStore = w.store;
				w.store.actionData.push(csiStore.nameObject("+ " + action.m_name, action.m_id));
			}

			w.set("autoComplete", false);
			this._widget = w;
			return w;
		},

		/**
		 * Create new action to add to drop-down
		 * @return {NewAction}
		 */
		_getNewAction: function () {
			return lang.mixin(new NewAction(), {
				m_id: "New" + this.aggregateNewNodeType,
				m_typeNode: this.aggregateNewNodeType
			});
		},

		/**
		 * Return parameters to use for New action controller
		 */
		_getNewControllerParams: function () {
			// reactLastInput for react inline editing
			var name = this.editNode?.get("_lastInput") || this.reactLastInput || "";

			var self = this;

			return {
				bRefNode: false,
				onStart: function () {
					this._canNavigate = function () {
						// summary: disallow Save & Go in this case
						return false;
					};

					this._canRepeat = function () {
						// summary: disallow Save & New in this case
						return false;
					};

					this._onPublishError = function (/*Error*/err) {
						// summary: changes error message display if user cannot edit Colored Material or Size Spec
						if (!this.isValidAction(true)) {
							return;
						}

						self.onNewError(this, err);

						if (!this.m_error) {
							this.m_error = err.message;
							this._errorCode = err.csiErrorCode;
						}

						this._errorException = err.csiErrorException;
						this._nPublished = 1;
						this.postProcess(false);
					};

					self._connectEvent(this, "onCreatePopup", function (view) {
						// add typed in value to add new form by default
						view.addDefaultValue(xml.ATTR_NAME, name);
					});
				},

				onEnd: function () {
					if (this.endStatus) {
						self._postActionGoToDialog(this);
					} else {
						self.resumeProcess();
						self.postProcess();
					}
				}
			};
		},

		/**
		 * Continue processing of aggregate controller once new controller is finished
		 * @param {Controller} ac
		 */
		_postActionGoToDialog: function (ac) {
			// set the value selected in the "Go to Dialog"
			this.newValue = ac.m_urlNode;

			// keyCode null will prevent from auto editing the next inline item
			this._keyCode = null;

			this.resumeProcess();
			this.process();

			// add new value to store
			var newNode = ac.getNode();
			if (newNode) {
				this.namesStore.add(csiStore.nameObject(newNode, null, ac.m_cache));
			}
		},

		/**
		 * Invoke New action if selected; otherwise, process selection as normal
		 */
		_onProcess: function () {
			var newAction = this._newAction;

			// this._widget can be null in case of react inline editing
			if (this._widget?.bClickNewAction) {
				// make sure to get params before closing dialog or else editNode is destroyed
				var params = this._getNewControllerParams();
				this._removeDialog();
				this.suspendProcess();
				csiAction.invoke(this.widget, null, newAction, params);
			} else {
				this.inherited(arguments);
			}
		},

		/** React */

		/**
		 * @override
		 * create list of select actions for React Selects
		 * @param {*} a - action to use for popup view 
		 * @param {Names} store - existing renderer store
		 * @return {SelectAction} list of select actions for React Selects 
		 */
		getSelectActions(a, store) {
			const onActionNew = (value) => {
				const  params = this._getNewControllerParams();
				this._removeDialog();
				this.suspendProcess();
				csiAction.invoke(this.widget, null, this._newAction, params);
			}

			const selectActions = this.inherited(arguments);

			const action = this._getNewAction();
			if (action) {
				action.resolve();
				this._newAction = action;
				selectActions.push({onAction: onActionNew, label: "+ " + action.m_name});
			}
			
			return selectActions;
		},

	});
});